import * as React from 'react'
import { Typography, Box, TextField, ConfirmationModal } from 'cs-kevlar-react'
import { ConfirmationModalProps } from 'cs-kevlar-react/lib/es/ConfirmationModal'
import { WithOptional } from 'cs-kevlar-react/lib/es/base'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'

// mark these props as optional since we set defaults
type OptionalKeys = 'message' | 'title'

interface ConfirmDeleteModalProps
  extends WithOptional<ConfirmationModalProps, OptionalKeys> {
  line1Text: string
  line2Text: string
  line3Text?: string
  inputLabelText: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bottomGutter: {
      marginBottom: theme.spacing(8),
    },
  }),
)

export const ConfirmDeleteModal: React.FunctionComponent<ConfirmDeleteModalProps> = ({
  line1Text,
  line2Text,
  line3Text,
  inputLabelText,
  onCancel,
  ...rest
}) => {
  const classes = useStyles({})

  const [confirmingDeleteText, setConfirmingDeleteText] = React.useState<
    string
  >('')

  const canDelete =
    confirmingDeleteText === 'DELETE' || confirmingDeleteText === 'delete'

  const onCancelClicked = () => {
    setConfirmingDeleteText('')

    onCancel && onCancel()
  }

  return (
    <ConfirmationModal
      onCancel={onCancelClicked}
      isConfirmDisabled={!canDelete}
      showCancelButton={false}
      confirmText="Confirm Delete"
      title="Confirm Delete"
      confirmButtonColor="secondary"
      {...rest}
      message={
        <React.Fragment>
          <Typography className={classes.bottomGutter}>{line1Text}</Typography>
          <Typography className={classes.bottomGutter}>{line2Text}</Typography>
          {!!line3Text && (
            <Typography className={classes.bottomGutter}>
              {line3Text}
            </Typography>
          )}
          <Box>
            <TextField
              onChange={e => setConfirmingDeleteText(e.target.value)}
              label={inputLabelText}
              value={confirmingDeleteText}
            />
          </Box>
        </React.Fragment>
      }
    />
  )
}
